import ReactPixel from 'react-facebook-pixel';

import { useAccount } from 'catering/context/providers/AccountProvider';
import {
  FACEBOOK_ADD_TO_CART_EVENT,
  PIXEL_INIT_OPTIONS
} from 'bento-ordering/base/constants/tracking';
import {
  selectCateringLocationById,
  useCateringLocations
} from 'catering/hooks/query';

export function useTrackEvent(cateringLocationId) {
  const { facebookPixelId } = useAccount();

  const { data: cateringLocation } = useCateringLocations({
    select: locations => {
      const selectedLocation = selectCateringLocationById(
        locations,
        cateringLocationId
      );

      return { selectedLocation };
    }
  });

  const trackEvent = ({ category, action, label, value }) => {
    if (window.BentoAnalytics) {
      window.BentoAnalytics.trackEvent(category, action, label, value);
    }

    if (facebookPixelId) {
      ReactPixel.init(facebookPixelId, {}, PIXEL_INIT_OPTIONS);
      ReactPixel.trackSingle(facebookPixelId, FACEBOOK_ADD_TO_CART_EVENT, {
        category,
        action,
        label,
        value
      });
    }

    if (cateringLocation && cateringLocation.selectedLocation) {
      const {
        fb_location_pixel_id: locationPixelId
      } = cateringLocation.selectedLocation.location;
      if (locationPixelId) {
        ReactPixel.init(locationPixelId, {}, PIXEL_INIT_OPTIONS);
        ReactPixel.trackSingle(locationPixelId, FACEBOOK_ADD_TO_CART_EVENT, {
          category,
          action,
          label,
          value
        });
      }
    }
  };

  return trackEvent;
}
